export default function getYearMachinesSalesSumChartConfig(showAVGofSUM, setShowAVGofSUM, currentData, averageOfSum, itemsPerPage, showMedianOfSUM, medianOfSUM) {
  return {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        // display: true,
        display: false,
        position: "bottom",
        labels: {
          generateLabels: () => {
            return [
              {
                text: "Średnia z sumy",
                fillStyle: "#FF7A00",
                strokeStyle: "#FF7A00",
                lineWidth: 2,
                hidden: !showAVGofSUM,
                index: 0,
              },
            ];
          },
          usePointStyle: true,
          pointStyle: "line",
        },
        onClick: () => setShowAVGofSUM(!showAVGofSUM),
      },
      tooltip: {
        callbacks: {
          title: () => "Sprzedaż za rok",
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.raw || 0;
            const index = context.dataIndex;
            const product = currentData[index];
            const isPreviousYear = label === "Poprzedni rok";
            const year = isPreviousYear ? currentData[index].PrevYear : currentData[index].CurrentYear; 
            const count = isPreviousYear ? product.PrevSummaryIncomeCount : product.CurrentSummaryIncomeCount || 0;
            const formattedValue = new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
            }).format(value);
            return `${year} ${currentData[index].MachineFullName}: ${formattedValue} (${count} szt.)`;
          },
        },
      },
      title: {
        display: false,
      },
      annotation: {
        annotations: {
          averageLine: {
            display: showAVGofSUM,
            type: "line",
            xMin: averageOfSum,
            xMax: averageOfSum,
            borderColor: "#FF7A00",
            borderWidth: 4,
            label: {
              display: showAVGofSUM,
              content: `  ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(averageOfSum)}  `,
              position: "end",
              backgroundColor: "#FF7A00",
              color: "white",
              padding: 2,
              
            },
          },
          medianLine: {
            type: "line",
            display: showMedianOfSUM,
            xMin: medianOfSUM,
            xMax: medianOfSUM,
            borderColor: "#666A71",
            borderWidth: 4,
            label: {
              display: showMedianOfSUM,
              content: `  ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(medianOfSUM)}  `,
              position: "end",
              backgroundColor: "#666A71",
              color: "white",
              padding: 2,
            },
          },
        },
      },
    },
    scales: {
      x: {
        position: "top",
        beginAtZero: true,
        title: {
          display: false,
        },
        ticks: {
          callback: (value) => {
            return new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(value);
          },
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
      },
      y: {
        position: "left",
        title: {
          display: true,
        },
        ticks: {
          autoSkip: false,
          maxTicksLimit: itemsPerPage,
          align: "start",
          mirror: false, 
          padding: 5,    
          crossAlign: "near",
        },
        grid: {
          drawTicks: false,
        }
      },
    },

    hover: {
      mode: "nearest",
      intersect: true,
    },
    animation: {
      duration: 0,
    },
  }
}